const {
    cloneDeep, forEach, reduce,
} = require('lodash');
const $ = require('jquery');

class CheckoutConfirmationController {
    constructor(settings, analyticsService, shopperService, orderInformationService) {
        this.settings = settings;
        this.analyticsService = analyticsService;
        this.shopperService = shopperService;
        this.orderInformationService = orderInformationService;
    }

    $onInit() {
        this.placedOrder = this.confirmation.Order;
        this.orderId = this.placedOrder.OrderId;
        this.orderStatus = this.placedOrder.OrderStatus;
        this.orderCancelled = this.orderStatus === 'Cancelled';
        this.RewardsCardName = this.settings.everydayRewards.cardName;
        this.EVoucherDisplayName = this.settings.checkout.eVoucherDisplayName;

        if (this.placedOrder) {
            if (!this.confirmation.IsPushedToDtm || !this.confirmation.IsPushedToGtm) {
                const orderWithoutDetail = cloneDeep(this.placedOrder);
                delete orderWithoutDetail.PaymentBreakdown;
                const analyticsObj = {
                    data: {
                        order: orderWithoutDetail,
                        orderDetails: this.placedOrder,
                        shopper: this.shopperService.shopper,
                        shopperDetails: undefined,
                        rewardsPointsConversionBase: this.settings.loyalty.rewardsConversionBase,
                    },
                };
                analyticsObj.type = 'orderAnalytics';
                this.analyticsService.push(analyticsObj);
            }

            if (this.confirmation.Order.IsRewardsSubscriptionPurchased) {
                this.rewardsPlus = {
                    isRewardsSubscriptionPurchased: true,
                    edrCardNumber: this.confirmation.Order.RewardsCardNumber,
                };

                this.shopperService.assignRewardsPlusPurchaseInfo(this.rewardsPlus);
            }
        }

        if (this.settings.siteCensus.responsysTrackingPixel) {
            this.addResponsysTrackingPixelToBody(this.createSourceString(this.settings.siteCensus.responsysTrackingPixel));
        }

        this.isDelivery = this.isDelivery(this.placedOrder.DeliveryMethod);
        this.deliveryTypeHeader = this.getDeliveryTypeHeader(this.placedOrder.DeliveryMethod);

        this.warningMessage = this.orderInformationService.getWarningMessage({
            order: this.confirmation,
            deliveryMethod: this.confirmation.Order.DeliveryMethod,
        });
    }

    stringFormat(string, args) {
        forEach(args, (value, key) => { string = string.replace(`{${key}}`, value); });
        return string;
    }

    calculateQuantity(products) {
        return reduce(products, (sum, product) => sum + product.Quantity, 0);
    }

    createSourceString(urlSetting) {
        return this.stringFormat(urlSetting, {
            OrderID: this.placedOrder.OrderId,
            OrderTotal: this.placedOrder.TotalIncludingGst,
            OrderQty: this.calculateQuantity(this.placedOrder.Products),
            ShopperID: this.shopperService.shopper.Id,
        });
    }

    addResponsysTrackingPixelToBody(sourceString) {
        $(`<img id="responsysTrackingPixel" src="${sourceString}">`).appendTo('body');
    }

    $onDestroy() {
        const element = $('#responsysTrackingPixel');
        if (element) {
            $('#responsysTrackingPixel').remove();
        }
    }

    isDelivery(deliveryMethod) {
        return deliveryMethod === this.settings.orderConfirmation.courierDeliveryMethod
            || deliveryMethod === this.settings.orderConfirmation.expressDeliveryMethod;
    }

    getDeliveryTypeHeader(deliveryMethod) {
        switch (deliveryMethod) {
            case this.settings.orderConfirmation.courierDeliveryMethod:
                return this.settings.orderConfirmation.courierOrderConfirmationHeader;
            case this.settings.orderConfirmation.expressDeliveryMethod:
                return this.settings.orderConfirmation.expressDeliveryOrderConfirmationHeader;
            case this.settings.orderConfirmation.pickupDeliveryMethod:
            case this.settings.orderConfirmation.hubspokDeliveryMethod:
                return this.settings.orderConfirmation.pickupDeliveryOrderConfirmationHeader;
            default:
                return '';
        }
    }
}

CheckoutConfirmationController.$inject = ['Settings', 'AnalyticsService', 'ShopperService', 'OrderInformationService'];

const checkoutConfirmationControllerComponentDefinition = {
    bindings: {
        confirmation: '<',
        showSaveCard: '<saveCard',
    },
    controller: CheckoutConfirmationController,
    template: require('./checkout-confirmation.component.html').trim(),
};

module.exports = {
    CheckoutConfirmationController,
    checkoutConfirmationControllerComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/order/confirmation/checkout-confirmation.component.js